import { createContext } from "react";

export const CraftContext = createContext()